module.exports = __webpack_public_path__ + "static/media/sensirion.1c11d3e6.png";